export enum ReportKeyTypeModel {
  Event,
  Preview
}